import React from "react";
import themePropTypes from "../theme-prop-types";

const ExpansionPanel = ({
  showBody,
  inlineHeader,
  header,
  subtitle,
  toggleExpansion,
  body
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  <div className='expansion-wrapper-web-sdk'>
    <div className='expansion-title-web-sdk' onClick={toggleExpansion}>
      <div className={inlineHeader ? "expansion-inline-web-sdk" : null}>
        {header}
      </div>
      <div className={inlineHeader ? "expansion-inline-web-sdk" : null}>
        {subtitle}
      </div>
    </div>
    <div
      className={`expansion-body-web-sdk ${
        showBody && "expansion-expanded-web-sdk"
      }`}
    >
      {body}
    </div>
  </div>
);
ExpansionPanel.propTypes = themePropTypes.expansionPanel;

export default ExpansionPanel;
